import { apiRequest } from '@/lib/api';
import { ProgramDraft } from '@/types/program';

export interface DraftResponse {
    statusCode: number;
    message: string;
    data: {
        draft: ProgramDraft;
    };
}

export interface DraftsListResponse {
    statusCode: number;
    message: string;
    data: {
        drafts: ProgramDraft[];
    };
}

// Helper function to convert date strings to Date objects
const convertDraftDates = (draft: any): ProgramDraft => ({
    ...draft,
    lastModified: new Date(draft.lastModified),
    createdAt: new Date(draft.createdAt),
    updatedAt: new Date(draft.updatedAt),
});

export const programDraftsApi = {
    // Get all drafts
    getAllDrafts: async (): Promise<DraftsListResponse> => {
        const response = await apiRequest<DraftsListResponse>('/api/programs/drafts');
        return {
            ...response,
            data: {
                ...response.data,
                drafts: response.data.drafts.map(convertDraftDates)
            }
        };
    },

    // Create new draft
    createDraft: async (programData: ProgramDraft['programData']): Promise<DraftResponse> => {
        const response = await apiRequest<DraftResponse>('/api/programs/drafts', {
            method: 'POST',
            body: programData,
        });
        return {
            ...response,
            data: {
                ...response.data,
                draft: convertDraftDates(response.data.draft)
            }
        };
    },

    // Update existing draft
    updateDraft: async (draftId: string, programData: ProgramDraft['programData']): Promise<DraftResponse> => {
        const response = await apiRequest<DraftResponse>(`/api/programs/drafts/${draftId}`, {
            method: 'PUT',
            body: programData,
        });
        return {
            ...response,
            data: {
                ...response.data,
                draft: convertDraftDates(response.data.draft)
            }
        };
    },

    // Delete draft
    deleteDraft: async (draftId: string): Promise<{ statusCode: number; message: string }> => {
        return apiRequest<{ statusCode: number; message: string }>(`/api/programs/drafts/${draftId}`, {
            method: 'DELETE',
        });
    },

    // Bulk delete drafts
    bulkDeleteDrafts: async (draftIds: string[]): Promise<{ statusCode: number; message: string }> => {
        return apiRequest<{ statusCode: number; message: string }>('/api/programs/drafts/bulk-delete', {
            method: 'DELETE',
            body: { draftIds },
        });
    },
}; 